import { render, staticRenderFns } from "./the-users.vue?vue&type=template&id=65110f05"
import script from "./the-users.vue?vue&type=script&lang=js"
export * from "./the-users.vue?vue&type=script&lang=js"
import style0 from "./the-users.vue?vue&type=style&index=0&id=65110f05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports